// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OpponentVideoItem__video-fd8163 {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
}

.OpponentVideoItem__videoContainer-b7aa29 {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/GridLayout/components/OpponentVideoItem/OpponentVideoItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".video {\n  object-fit: contain;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.videoContainer {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video": `OpponentVideoItem__video-fd8163`,
	"videoContainer": `OpponentVideoItem__videoContainer-b7aa29`
};
module.exports = ___CSS_LOADER_EXPORT___;
